import db from '../../utils/db'
import {get} from '../../utils/auth'

const tabs = {
  state: {
    headerActiveName: '/xtgl',
    activeName : {},
    tabRoutes: [
      // {
      //   meta: {
      //     keepAlive: true,
      //     title: '首页'
      //   },
      //   fullPath: 'dashboard',
      //   name: 'dashboard',
      //   path: 'dashboard',
      //   params: {},
      //   query: {}
      // }
    ]
  },
  mutations: {
    set_active_name(state, data) {
      state.activeName = data
    },
    set_header_active_name(state, data) {
      state.headerActiveName = data
      this.commit('set_header_active_name_to_db')
    },
    set_active_tabs(state, data) {
      state.tabRoutes = data
    },
    close_tab(state, {routeName, vm, newRouteName}) {
      let openedtabs = state.tabRoutes
      let index
      if (routeName.indexOf('reportQuery')===-1) {
        index = openedtabs.findIndex(tab => (tab.name === routeName))
      } else {
        index = openedtabs.findIndex(tab=> (tab.name+tab.query.reportid === routeName ))
      }
      openedtabs.splice(index,1)
      if (newRouteName) {
        let newRoute = openedtabs.find(tab=> (tab.name === newRouteName))
        if (newRoute) {
          this.commit('set_active_name',newRoute.name)
          vm.$router.push(newRoute)
        } else {
          let newRoute = openedtabs[openedtabs.length-1]
          this.commit('set_active_name',newRoute.name)
          vm.$router.push(newRoute)
        }
      } else {
        let newRoute = openedtabs[openedtabs.length-1]
        if (newRoute.name === 'reportQuery') {
          this.commit('set_active_name',newRoute.name + newRoute.query.reportid)
        } else {
          this.commit('set_active_name',newRoute.name)
        }
        vm.$router.push(newRoute)
      }
      state.tabRoutes = openedtabs
      this.commit('set_tabs_to_db')
    },
    open_new_tabs (state, newRoute) {
      if (newRoute.fullPath.startsWith('/printView')) return
      if (newRoute.name) {
        if (newRoute.name === 'reportQuery') {
          let openedtabs = state.tabRoutes
          let index = openedtabs.findIndex(tab=> (tab.name === newRoute.name && Number(tab.query.reportid)===Number(newRoute.query.reportid)))
          if (index === -1) {
            state.tabRoutes.push({
              meta: newRoute.meta,
              fullPath: newRoute.fullPath,
              name: newRoute.name,
              path:  newRoute.path,

              params: newRoute.params,
              query: newRoute.query
            })
            state.activeName = newRoute.name + newRoute.query.reportid
            this.commit('set_tabs_to_db')
          } else {
            state.activeName = openedtabs[index].name + openedtabs[index].query.reportid
          }
        } else {
          let openedtabs = state.tabRoutes
          let index = openedtabs.findIndex(tab=> (tab.name === newRoute.name))
          if (index === -1) {
            state.tabRoutes.push({
              meta: newRoute.meta,
              fullPath: newRoute.fullPath,
              name: newRoute.name,
              path:  newRoute.path,
              params: newRoute.params,
              query: newRoute.query
            })
            state.activeName = newRoute.name
            this.commit('set_tabs_to_db')
          } else {
            openedtabs[index].fullPath = newRoute.fullPath
            openedtabs[index].params = newRoute.params
            openedtabs[index].query = newRoute.query
            state.activeName = openedtabs[index].name
          }
        }
      }
    },
    set_tabs_to_db (state) {
      db.get(get('token')).set('tabRoutes',state.tabRoutes).write()
    },
    set_header_active_name_to_db (state) {
      db.get(get('token')).set('headerActiveName',state.headerActiveName).write()
    },

  },
  actions: {
  },
  getters: {
  }
}
export default tabs
